<div class="factor">
  <gen-field-viewer *ngIf="factor"
                    [field]="factor"
  ></gen-field-viewer>
</div>
